<template>
  <div class="info-item info-block">
    <div class="info-item-body">
      <div class="stories-title">{{ story.title }}</div>
      <div>
        <div
          ref="text"
          class="stories-text"
          :class="{ 'stories-text-short': textShort }"
        >
          {{ story.text }}
        </div>
        <div v-if="showLink" class="stories-more">
          <span v-if="textShort" @click="showFull" class="stories-more-text">
            {{ $t("feed.readCompletely") }}
          </span>
          <span v-else @click="showCut" class="stories-more-text">
            {{ $t("feed.hide") }}
          </span>
        </div>
      </div>
    </div>
    <div class="info-item-footer">
      <div class="stories-votes">
        <storyVote
          v-if="user && user.id !== story.owner.id"
          :up="true"
          :id="story.id"
          :active="story.liked"
          :feed="true"
        ></storyVote>
        <div
          class="stories-rating"
          :class="{
            good: story.rating > 0,
            bad: story.rating < 0,
            neutral: story.rating === 0,
            'not-my': user && user.id !== story.owner.id,
          }"
        >
          {{ story.rating }}
        </div>
        <storyVote
          v-if="user && user.id !== story.owner.id"
          :up="false"
          :id="story.id"
          :active="story.disliked"
          :feed="true"
        ></storyVote>
      </div>
      <div class="info-right">
        <redirectButton
          pathname="profile"
          :params="{ id: story.owner.id }"
          :html="story.owner.name"
          class="info-author"
        ></redirectButton>
        <div class="info-time">
          {{ getVerbalDate(story.created_at * 1000) }}
        </div>
        <redirectButton
          pathname="profile"
          :params="{ id: story.owner.id }"
          :html="''"
          :style="{
            'background-image': story.owner.avatar
              ? 'url(' + story.owner.avatar + ')'
              : '',
          }"
          class="info-avatar"
          :class="{ 'no-avatar': !story.owner.avatar }"
        ></redirectButton>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import redirectButton from "@/components/Buttons/Redirect";
import storyText from "@/components/Blocks/StoryText";
import storyVote from "@/components/Blocks/StoryVote";
import { formatDateTime } from "@/mixins/formatDateTime";

export default {
  name: "Feed",
  props: {
    i18n: Object,
  },
  components: {
    redirectButton,
    storyText,
    storyVote,
  },
  mixins: [formatDateTime],
  props: {
    story: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      initialHeight: 0,
      maxHeight: 240,
      showLink: false,
      textShort: false,
    };
  },
  mounted() {
    this.initialHeight = 0;
    setTimeout(() => {
      this.initialHeight = this.$refs.text.offsetHeight;
      if (this.initialHeight > this.maxHeight) {
        this.showLink = true;
        this.textShort = true;
      }
    }, 100);
  },
  computed: {
    ...mapGetters({
      user: "user/fetchUser",
      userIsEmpty: "user/isEmpty",
    }),
  },
  methods: {
    showFull() {
      this.textShort = false;
    },
    showCut() {
      this.textShort = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/layout/_stories-block";
@import "~@/assets/styles/components/_votes";
</style>
